

















































import { api } from "@/api/api";
import { ApiGetAreaDto } from "@/api/generated/Api";
import AreaModal from "@/components/administration/location/AreaModal.vue";
import BaseModal from "@/components/shared/BaseModal.vue";
import BaseTooltipIconButton from "@/components/shared/button/BaseTooltipIconButton.vue";
import BaseTable from "@/components/shared/table/BaseTable.vue";
import { getInitialModalData, useOpenModal } from "@/fragments/modal/useOpenModal";
import { LoadingType } from "@/shared/enums/loading-type.enum";
import { ModalType } from "@/shared/enums/modalTypeEnum";
import { globalLoadingWrapper } from "@/shared/helpers/loadingHelpers";
import { useRouter } from "@/shared/useHelpers";
import { defineComponent, onMounted, ref } from "@vue/composition-api";

export default defineComponent({
  name: "AreaPage",
  components: { AreaModal, BaseTooltipIconButton, BaseModal, BaseTable },

  setup() {
    const router = useRouter();
    const search = ref("");
    const modalData = ref(getInitialModalData());
    const areaList = ref<ApiGetAreaDto[]>([]);

    const headers = [
      { text: "Lokasjon", value: "place" },
      { text: "Kommune", value: "municipality" },
      {
        text: "Fylke",
        value: "county",
      },
      { text: "Land", value: "country" },
      { text: "Handlinger", value: "actions" },
    ];

    const loadData = async () => {
      await globalLoadingWrapper({ type: LoadingType.SkeletonTable }, async () => {
        areaList.value = (await api.area.getAreasAsync()).data;
      });
    };

    onMounted(() => {
      loadData();
    });

    const openNewArea = useOpenModal(ModalType.Add, "lokasjon", modalData);
    const openEditArea = useOpenModal(ModalType.Edit, "lokasjon", modalData);

    const navigateToArea = (item: ApiGetAreaDto) => {
      router.push({
        name: "locations",
        params: { areaId: item.id.toString() },
      });
    };

    return {
      navigateToArea,
      loadData,
      modalData,
      openEditArea,
      openNewArea,
      areaList,
      search,
      headers,
    };
  },
});
